
















































import Vue from 'vue';
import { ECartTypeId } from '@ringana/configs';
import OldFormatHelper from '../../../helpers/OldFormatHelper';
import PriceMethods from '../../../methods/PriceMethods';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import CustomSelect from '../../layout/inputs/CustomSelect.vue';
import { IShoppingCartIndividual } from '../../../common/interfaces/cart.interface';
import { ILimitingObject } from '../../../common/interfaces/limiting.interface';
import { IProduct } from '../../../common/interfaces/products.interface';
import { IOldCustomSelectOption } from '../../../common/interfaces/shared.interface';
import CookieHelper from '../../../helpers/CookieHelper';
import FormatHelper from '../../../helpers/FormatHelper';

interface IAddToCartTranslations {
  addToCart: string;
  onePiece: string;
  twoPieces: string;
  threePieces: string;
  fourPieces: string;
  fivePieces: string;
}

interface IAddToCartComponent {
  cartSelect: IOldCustomSelectOption[];
  defaultQuantitySelect: IOldCustomSelectOption[];
  formatHelper: typeof OldFormatHelper;
  merchandiseSelect: IOldCustomSelectOption[];
  quantitySelect: IOldCustomSelectOption[];
}

export default Vue.extend({
  components: { CustomButton, CustomSelect },
  data(): IAddToCartComponent {
    return {
      cartSelect: [],
      defaultQuantitySelect: [
        { code: 1, label: this.t.onePiece },
        { code: 2, label: this.t.twoPieces },
        { code: 3, label: this.t.threePieces },
        { code: 4, label: this.t.fourPieces },
        { code: 5, label: this.t.fivePieces },
      ],
      formatHelper: OldFormatHelper,
      merchandiseSelect: [],
      quantitySelect: [
        { code: 1, label: this.t.onePiece },
        { code: 2, label: this.t.twoPieces },
        { code: 3, label: this.t.threePieces },
        { code: 4, label: this.t.fourPieces },
        { code: 5, label: this.t.fivePieces },
      ],
    };
  },
  computed: {
    hideElementBecauseLimitingIsActive(): boolean {
      return !this.limiting.active || (this.limiting.active && this.limiting.shoppingAllowed);
    },
    selectedMerchandiseCartId(): number | undefined {
      return this.availableCarts.find(cart => cart.cartTypeId === ECartTypeId.PERSONAL_USE)?.cartId;
    },
    showCartSelect(): boolean {
      return !this.productInfo.isMerchandise && this.hasMultipleCarts && this.hideElementBecauseLimitingIsActive;
    },
    showMerchandiseCartSelect(): boolean {
      return this.productInfo.isMerchandise && this.hideElementBecauseLimitingIsActive && !!this.selectedMerchandiseCartId && this.hasMultipleCarts;
    },
  },
  props: {
    addToCartButtonDisplayMode: {
      default: `full-button`,
      type: String,
    },
    availableCarts: {
      required: true,
      type: Array as () => IShoppingCartIndividual[],
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    loading: {
      required: true,
      type: Boolean,
    },
    maxToCart: {
      default: 999,
      type: Number,
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct,
    },
    selectedCartId: {
      required: true,
      validator: prop => Number.isInteger(prop) || prop === null,
    },
    showQuantitySelect: {
      default: true,
      type: Boolean,
    },
    t: {
      required: true,
      type: Object as () => IAddToCartTranslations,
    },
  },
  methods: {
    ...PriceMethods,
    addItemToCart(): void {
      this.$emit(`add-item-to-cart`, this.productInfo.isMerchandise);
    },
    resetOptions(): void {
      this.quantitySelect = this.defaultQuantitySelect.filter(option => option.code <= this.maxToCart);
    },
    setUpCartDropdownData(): void {
      if(this.cartSelect.length === 0) {
        this.availableCarts.forEach((cart: IShoppingCartIndividual): void => {
          this.cartSelect.push({ code: cart.cartId, label: this.formatHelper.formatFullAddress(cart.invoiceAddress, cart.cartTypeId) });
        });
      }
    },
    setUpMerchandiseDropdownData(): void {
      if(this.merchandiseSelect.length === 0) {
        const cart = this.availableCarts.find(availableCart => availableCart.cartId === CookieHelper.getPersonalUseCartId());
        if(cart) {
          this.merchandiseSelect.push({
            code: cart.cartId,
            label: FormatHelper.formatFullAddress(cart.invoiceAddress, cart.cartTypeId),
          });
        }
      }
    },
    updateSelectedAmount(event: unknown) {
      this.$emit(`update:selected-product-amount`, event);
    },
    updateSelectedCartId(event: unknown) {
      this.$emit(`update:selected-cart-id`, event);
    },
  },
  watch: {
    availableCarts: {
      handler(): void {
        this.setUpCartDropdownData();
        this.setUpMerchandiseDropdownData();
      },
      immediate: true,
    },
    maxToCart: {
      handler(): void { this.resetOptions(); },
      immediate: true,
    },
  },
});
